import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadProductCategories = async () => {
  try {
    const response = await Axios.get('product-categories');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

const loadOneProductCategory = async (name) => {
  try {
    const respnse = await Axios.get('product-categories/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadProductCategory = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/product-categories');
        const responseData = await response.data;
        return {...responseData, category: {}};
        
      default:
        const data = await loadOneProductCategory(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const useProductCategoriesAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('product-categories', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('product_category_response', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('product-categories/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('product_category_update', data.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useProductCategoriesAPI;


